import api from '@/apis/di/cashWithdrawTypeAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid Loại CCDC
export const useCashWithdrawType = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onCashWithdrawType = (payload, row, column) => {
    payload.sort = 'cash_withdraw_type_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const toolTypeComboConfig = {
    data: comboboxDataRemote,
    displayField: 'cash_withdraw_type_code',
    valueField: 'cash_withdraw_type_id',
    queryMode: 'remote',
    dropdownWidth: 500,
    comboboxLoadData: onCashWithdrawType,
  };

  // Sự kiện load combo trên grid
  return {
    toolTypeComboConfig,
    onCashWithdrawType, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
